import { IBook } from 'marketing-site/@types/generated/contentful'
import useModalOpenState from 'marketing-site/lib/useModalOpenState'
import { CTAButton } from 'marketing-site/src/library/elements/CTAButton'
import { Image } from 'marketing-site/src/library/elements/Image'
import { Logo } from 'marketing-site/src/library/elements/Logo'
import { ModalWithPersistedState } from 'marketing-site/src/library/elements/ModalWithPersistedState'
import { RichText } from 'marketing-site/src/library/elements/RichText'
import useTranslate from 'marketing-site/src/library/hooks/useTranslate'
import { CTATheme, makeHyphensUnbreakable } from 'marketing-site/src/library/utils'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'
import { transformLogo } from 'marketing-site/src/transformers/elements/ContentfulLogo'
import React, { useEffect, useState } from 'react'
import { BookOrGuideForm } from '../hero/form'
import styles from './hero.scss'

export type IProps = Omit<IBook, 'sys' | 'toPlainObject'>

export const testIds = {
  downloadButton: 'test-resources-hero-download-button',
}

export function ResourcesHero(props: IProps) {
  const [modalOpen, openModal, closeModal] = useModalOpenState()
  const [startAnimation, setStartAnimation] = useState(false)
  const { translate } = useTranslate()

  useEffect(() => {
    setStartAnimation(true)
  }, [])

  const animationClass = startAnimation ? 'image-stack--animated' : ''
  const title = makeHyphensUnbreakable(props.fields.shortTitle || props.fields.title)

  return (
    <div className="resources-hero">
      <div className="inner">
        <div className="content-left">
          <h1 className="title">
            <RichText html={title} />
          </h1>
          <p className="description">{props.fields.description}</p>
          <div className="cta" data-testid={testIds.downloadButton}>
            <CTAButton
              text="Download now"
              onClick={openModal}
              arrow={false}
              bgColor={CTATheme.BlackFill}
            />
            <ModalWithPersistedState isOpen={modalOpen} onRequestClose={closeModal}>
              <BookOrGuideForm
                downloadUrl={props.fields.bookPdf.fields.file.url}
                downloadText="Download your copy"
                resourceType={props.fields.resourceType}
              />
            </ModalWithPersistedState>
          </div>
          {props.fields.featuredLogos ? (
            <div className="featured-logos">
              <p className="feature-logos-title">{translate('Featuring experts from:')}</p>
              <div className="logos">
                {props.fields.featuredLogos.map(transformLogo).map((logo, key) => (
                  <Logo key={key} {...logo} />
                ))}
              </div>
            </div>
          ) : null}
        </div>
        <div className="content-right">
          <div className="background"></div>
          <div className="cover-image">
            <Image {...transformImage(props.fields.coverPhoto)} />
            {props.fields.pageStackImage ? (
              <div className={`image-stack image-stack--bg ${animationClass}`}>
                <Image {...transformImage(props.fields.pageStackImage)} />
              </div>
            ) : null}
            {props.fields.pageStackImageTwo ? (
              <div className={`image-stack image-stack--bg ${animationClass}`}>
                <Image {...transformImage(props.fields.pageStackImageTwo)} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
